export default "__VITE_ASSET__B2qAkSg1__"